import type { PriceListApiResponse } from '../types';

export function sortLists(lists: PriceListApiResponse[] | undefined) {
  if (!lists) {
    return lists;
  }

  return [...lists].sort((a, b) => a.name.localeCompare(b.name));
}
